"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _RequestStatusTypes = _interopRequireWildcard(require("settings-ui-sdk/constants/RequestStatusTypes"));

var MIN_SEARCHABLE_LENGTH = 6;

var MANAGE_DOMAINS_HREF = "/domains/" + _hubspot.default.get();

var PagesSettingsHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PagesSettingsHeader, _PureComponent);

  function PagesSettingsHeader() {
    (0, _classCallCheck2.default)(this, PagesSettingsHeader);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PagesSettingsHeader).apply(this, arguments));
  }

  (0, _createClass2.default)(PagesSettingsHeader, [{
    key: "isLoading",
    value: function isLoading() {
      return this.props.domainsRequestStatus === _RequestStatusTypes.default.PENDING;
    }
  }, {
    key: "renderDomainValue",
    value: function renderDomainValue(_ref) {
      var children = _ref.children;

      if (this.isLoading()) {
        return _react.default.createElement("div", {
          className: "align-center"
        }, _react.default.createElement("div", null, children), _react.default.createElement(_UILoadingSpinner.default, {
          size: "extra-small"
        }));
      }

      return children;
    }
  }, {
    key: "renderDomainPicker",
    value: function renderDomainPicker() {
      var _this$props = this.props,
          isAllDomainsSelected = _this$props.isAllDomainsSelected,
          domainOptions = _this$props.domainOptions,
          selectedDomain = _this$props.selectedDomain;
      return _react.default.createElement(_UIMultiColumnItem.default, {
        horizontalAlign: "left",
        titleText: _I18n.default.text('marketing.pages.modifyingWithInheritance')
      }, _react.default.createElement(_UISelect.default, {
        "data-test-id": "domain-input",
        buttonUse: "transparent",
        options: domainOptions,
        searchable: domainOptions.length > MIN_SEARCHABLE_LENGTH,
        value: selectedDomain,
        onChange: this.props.onSelectedDomainChange,
        valueComponent: this.renderDomainValue.bind(this),
        disabled: this.isLoading(),
        className: "p-left-1",
        menuWidth: "auto"
      }), isAllDomainsSelected && _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.pages.allDomainsHelp"
      })));
    }
  }, {
    key: "renderDomainHeader",
    value: function renderDomainHeader() {
      return _react.default.createElement(_UIMultiColumn.default, {
        className: "m-bottom-10"
      }, _react.default.createElement(_UIMultiColumnGroup.default, null, this.renderDomainPicker(), _react.default.createElement(_UIMultiColumnItem.default, {
        horizontalAlign: "right",
        verticalAlign: "top"
      }, _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        size: "small",
        href: MANAGE_DOMAINS_HREF
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.pages.buttonLabels.manageDomains"
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activeTab = _this$props2.activeTab,
          hasSystemPagesAccess = _this$props2.hasSystemPagesAccess,
          hasSiteSettingsTemplatesAccess = _this$props2.hasSiteSettingsTemplatesAccess;
      return _react.default.createElement("div", null, _react.default.createElement(_UISubheader.default, {
        use: "condensed",
        className: "m-bottom-0",
        title: _I18n.default.text('marketing.links.webPages')
      }), this.renderDomainHeader(), _react.default.createElement(_UITabs.default, {
        use: "enclosed",
        selected: activeTab,
        onSelectedChange: this.props.onSelectedTabChange,
        className: "page-tabs m-bottom-10"
      }, hasSiteSettingsTemplatesAccess && _react.default.createElement(_UITab.default, {
        className: "page-tabs-templates",
        tabId: _UrlPathParams.PAGE_TEMPLATES,
        title: _I18n.default.text('marketing.pages.buttonLabels.templates')
      }), _react.default.createElement(_UITab.default, {
        className: "page-tabs-branding",
        tabId: _UrlPathParams.PAGE_BRANDING,
        title: _I18n.default.text('marketing.pages.buttonLabels.branding')
      }), _react.default.createElement(_UITab.default, {
        className: "page-tabs-personalization",
        tabId: _UrlPathParams.PAGE_PERSONALIZATION,
        title: _I18n.default.text('marketing.pages.buttonLabels.personalization')
      }), _react.default.createElement(_UITab.default, {
        className: "page-tabs-integrations",
        tabId: _UrlPathParams.PAGE_INTEGRATIONS,
        title: _I18n.default.text('marketing.pages.buttonLabels.integrations')
      }), _react.default.createElement(_UITab.default, {
        className: "page-tabs-seo",
        tabId: _UrlPathParams.PAGE_SEO,
        title: _I18n.default.text('marketing.pages.buttonLabels.seoAndCrawlers')
      }), hasSystemPagesAccess && _react.default.createElement(_UITab.default, {
        className: "page-tabs-system-pages",
        tabId: _UrlPathParams.SYSTEM_PAGES,
        title: _I18n.default.text('marketing.pages.buttonLabels.systemPages')
      })));
    }
  }]);
  return PagesSettingsHeader;
}(_react.PureComponent);

PagesSettingsHeader.propTypes = {
  activeTab: _react.PropTypes.string.isRequired,
  domainOptions: _react.PropTypes.array.isRequired,
  onSelectedDomainChange: _react.PropTypes.func.isRequired,
  onSelectedTabChange: _react.PropTypes.func.isRequired,
  selectedDomain: _react.PropTypes.string.isRequired,
  isAllDomainsSelected: _react.PropTypes.bool.isRequired,
  domainsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  hasSystemPagesAccess: _react.PropTypes.bool.isRequired,
  hasSiteSettingsTemplatesAccess: _react.PropTypes.bool.isRequired
};
var _default = PagesSettingsHeader;
exports.default = _default;
module.exports = exports.default;